import LoginService from "@/utils/loginService";
import tokenService from "@/utils/tokenService";
import { App } from "@vue/runtime-core";
// import { Router, useRoute, useRouter } from "vue-router";
import Router from "@/routes";
import { createStore } from "vuex";
import { cloneDeep, uniq, get, merge } from 'lodash'
import { dictionary, dictGetters, dictMutations, dictActions } from "./dictionary";

const store = createStore({
  state: {
    userInfo: {
      name: '管理员',
      avatar: '',
      age: 27,
      sex: '男'
    },
    currentParkInfo: {
      id: 1,
    } as any,
    globalLoading: false,
    globalFileProgressVisible: false,
    globalFileProgressValue: false,
    loadingBeginDate: {} as any,
    menuList: [] as any[],
    breadList: [],
    currentLayoutMenus: [],
    currentIndex: 0,
    currentPath: '',
    userPermissionList: [],
    isNotificationRead: false,
    cacheMenuList: {} as any,

    // 可以在多页 tab 模式下显示的页面
    pool: [],
    // 当前显示的多页面列表
    opened: [
      { name: 'workbench', fullPath: '/workbench', path: '/workbench', meta: { auth: true, title: '工作台' } },
    ],
    // 已经加载多标签页数据
    openedLoaded: false,
    // 当前页面
    current: '',
    // 需要缓存的页面 name
    keepAlive: [] as any,
    // 内容全屏
    contentFullScreen: false,

    //
    menuSideState: true,

    // 项目储备
    projectReserveInfo: {},

    ...dictionary,
  },
  getters: {
    helloUser: state => "Hello " + state.userInfo.name,
    loadingFlag: state => state.globalLoading,
    getLoadingBeginDate: state => state.loadingBeginDate,
    getCurrentParkId: state => {
        return state.currentParkInfo.id ? state.currentParkInfo.id : 1;
    },
    getTargetUrl: () => {
      const dev = process.env.NODE_ENV == 'development' ? true : false;
      let url: any = "http://wxct.wxskii.com:8001/"
      if (dev) {
        // 替换为本地地址
        url = 'http://localhost:8080/'
      }
      return url;
    },
    allProjectPermission: state => state.userPermissionList.indexOf("investment:project-reserve:all-permission") > 0,
    ...dictGetters,
  },
  mutations: {
    setCurrentParkInfo: (state)=>{
      state.currentParkInfo = {id: 1};
    },
    setProjectReserveInfo: (state, payLoad) => {
      state.projectReserveInfo = payLoad;
    },
    resetKeepAlive: (state) => {
      state.opened = [
        { name: 'workbench', fullPath: '/workbench', path: '/workbench', meta: { auth: true, title: '工作台' } },
      ];
      state.keepAlive = [];
    },
    toggleSide: (state) => {
      state.menuSideState = !state.menuSideState;
    },
    setUser: (state, payload) => {
      state.userInfo = payload;
    },
    openLoading: state => {
      state.globalLoading = true
      state.loadingBeginDate = new Date();
    },
    closeLoading: state => {
      state.globalLoading = false
    },
    setGlobalFileProgressValue(state, payload){
      state.globalFileProgressValue = payload;
    },
    setGlobalFileProgressVisble(state, payload){
      state.globalFileProgressVisible = payload;
    },
    setBreadList(state, breadList) {
      state.breadList = breadList;
    },
    setState: (state, payload) => {
      Object.assign(state, payload);
    },
    reloadMask: (state, payload) => {
      state.globalLoading = false;
    },
    setUserInfo(state, user) {
      state.userInfo = user;
    },
    setMenuList: (state, data) => {
      state.menuList = setKeyToMenuTree(data);
      console.log('state.menuList', state.menuList);
      store.commit("setCacheMenuList", cacheMenuList);
    },
    setLayoutMenus: (state, data) => {
      state.currentLayoutMenus = []
      state.currentLayoutMenus = data;
    },
    setCurrentIndex: (state, data) => {
      state.currentIndex = data;
    },
    setCurrentPath: (state, data) => {
      state.currentPath = data;
    },

    setUserPermissionList: (state, data) => {
      state.userPermissionList = data;
    },
    setNotificationRead: (state) => {
      state.isNotificationRead = true;
    },
    cancelNotificationRead: (state) => {
      state.isNotificationRead = false;
    },
    setCacheMenuList: (state, cacheList) => {
      state.cacheMenuList = cacheList;
    },
    setContentFullScreen: (state, data) => {
      state.contentFullScreen = data;
    },

    /**
     * @description 增加一个页面的缓存设置
     * @param {Object} state state
     * @param {String} name name
     */
    keepAlivePush(state, name) {
      const keep: any = cloneDeep(state.keepAlive)
      keep.push(name)
      state.keepAlive = uniq(keep)
    },
    /**
     * @class current
     * @description 设置当前激活的页面 fullPath
     * @param {Object} state state
     * @param {String} fullPath new fullPath
     */
    currentSet(state, fullPath) {
      state.current = fullPath
    },
    /**
     * @description 删除一个页面的缓存设置
     * @param {Object} state state
     * @param {String} name name
     */
    keepAliveRemove(state, name) {
      const list = cloneDeep(state.keepAlive)
      const index = list.findIndex((item: any) => item === name)
      if (index !== -1) {
        list.splice(index, 1)
        state.keepAlive = list
      }
    },
    /**
     * @class pool
     * @description 保存 pool (候选池)
     * @param {Object} state state
     * @param {Array} routes routes
     */
    pageInit(state, routes) {
      const pool: any = []
      const push = function (routes: any) {
        routes.forEach((route: any) => {
          if (route.children && route.children.length > 0) {
            push(route.children)
          } else if (!route.hidden) {
            const { meta, name, path } = route
            pool.push({ meta, name, path })
          }
        })
      }
      push(routes)
      state.pool = pool
      // console.log('state.pool', state.pool);
    },
    ...dictMutations,
  },
  actions: {
    smoothCloseLoading: context => {
      // let currentDate = new Date();
      // let distance = currentDate.getTime() - context.state.loadingBeginDate.getTime();
      // let timeout = 500 - distance;
      // timeout = timeout < 0 ? 0 : timeout;
      setTimeout(() => {
        context.commit("closeLoading");
      }, 500);
    },
    setMenuByRoute(context, route) {
      const { state } = context;
      const { breadList } = getCurrentMenuAndBreadListFromStateByRoute(state, route);
      // console.log(breadList);
      context.commit('setBreadList', breadList);
    },

    async close({ state, commit, dispatch }, { tagName }) {
      // 预定下个新页面
      let newPage: any = {}
      const isCurrent = state.current === tagName
      // 如果关闭的页面就是当前显示的页面
      if (isCurrent) {
        // 去找一个新的页面
        const len = state.opened.length
        for (let i = 0; i < len; i++) {
          if (state.opened[i].fullPath === tagName) {
            newPage = state.opened[i - 1];
            // newPage = i < len - 1 ? state.opened[i + 1] : state.opened[i - 1]
            break
          }
        }
      }
      // 找到这个页面在已经打开的数据里是第几个
      const index = state.opened.findIndex((page:any) => page.fullPath === tagName)
      if (index >= 0) {
        // 如果这个页面是缓存的页面 将其在缓存设置中删除
        commit('keepAliveRemove', state.opened[index].name)
        // 更新数据 删除关闭的页面
        state.opened.splice(index, 1)
      }
      // 决定最后停留的页面
      if (isCurrent) {
        const { name = 'workbench', params = {}, query = {} } = newPage
        const routerObj = { name, params, query }
        let router = Router.getRouter();
        // console.log('router', Router.getRouter(), routerObj);
        await router.push(routerObj)
      }
    },
    async openedUpdate({ state, commit, dispatch }, { index, params, query, fullPath }) {
      // 更新页面列表某一项
      const page: any = state.opened[index]
      page.params = params || page.params
      page.query = query || page.query
      page.fullPath = fullPath || page.fullPath
      state.opened.splice(index, 1, page)
    },
    async open({ state, commit, dispatch }, { name, params, query, fullPath, meta }) {
      // 已经打开的页面
      const opened = state.opened
      // 判断此页面是否已经打开 并且记录位置
      let pageOpendIndex = 0
      const pageOpend = opened.find((page: any, index: any) => {
        const same = page.fullPath === fullPath
        pageOpendIndex = same ? index : pageOpendIndex
        return same
      })
      if (pageOpend) {
        // 页面以前打开过
        await dispatch('openedUpdate', {
          index: pageOpendIndex,
          params,
          query,
          fullPath
        })
      } else {
        // 页面以前没有打开过
        const page = state.pool.find((t: any) => t.name === name)
        // 如果这里没有找到 page 代表这个路由虽然在框架内 但是不参与标签页显示
        if (page) {
          await dispatch('add', {
            tag: merge({}, page),
            params,
            query,
            fullPath
          })
        }
      }
      // 如果这个页面需要缓存 将其添加到缓存设置
      if (isKeepAlive({ meta })) commit('keepAlivePush', name)
      // 设置当前的页面
      commit('currentSet', fullPath)
    },
    async add({ state, commit, dispatch }, { tag, params, query, fullPath }) {
      // 设置新的 tag 在新打开一个以前没打开过的页面时使用
      const newTag = tag
      newTag.params = params || newTag.params
      newTag.query = query || newTag.query
      newTag.fullPath = fullPath || newTag.fullPath
      // 添加进当前显示的页面数组
      let index = state.opened.findIndex((tag: any) => tag.fullPath == state.current)
      if (index > -1) {
        state.opened.splice(index + 1, 0, newTag);
      } else {
        state.opened.push(newTag)
      }
      // 如果这个页面需要缓存 将其添加到缓存设置
      if (isKeepAlive(newTag)) commit('keepAlivePush', tag.name)
    },
    async closeLeft({ state, commit, dispatch }, { pageSelect } = {}) {
      const pageAim = pageSelect || state.current
      let currentIndex = 0
      state.opened.forEach((page: any, index:any) => {
        if (page.fullPath === pageAim) currentIndex = index
      })
      if (currentIndex > 0) {
        // 删除打开的页面 并在缓存设置中删除
        for (let i = state.opened.length - 1; i >= 0; i--) {
          if (state.opened[i].name === 'workbench' || i >= currentIndex) {
            continue
          }

          commit('keepAliveRemove', state.opened[i].name)
          state.opened.splice(i, 1)
        }
      }
      // 设置当前的页面
      state.current = pageAim
      let router = Router.getRouter();
      if (router.currentRoute.value.fullPath !== pageAim) await router.push(pageAim)
    },
    async closeRight({ state, commit, dispatch }, { pageSelect } = {}) {
      const pageAim = pageSelect || state.current
      let currentIndex = 0
      state.opened.forEach((page: any, index:any) => {
        if (page.fullPath === pageAim) currentIndex = index
      })
      // 删除打开的页面 并在缓存设置中删除
      for (let i = state.opened.length - 1; i >= 0; i--) {
        if (state.opened[i].name === 'workbench' || currentIndex >= i) {
          continue
        }

        commit('keepAliveRemove', state.opened[i].name)
        state.opened.splice(i, 1)
      }
      // 设置当前的页面
      state.current = pageAim
      let router = Router.getRouter();
      if (router.currentRoute.value.fullPath !== pageAim) await router.push(pageAim)
    },
    async closeOther({ state, commit, dispatch }, { pageSelect } = {}) {
      const pageAim = pageSelect || state.current
      let currentIndex = 0
      state.opened.forEach((page: any, index:any) => {
        if (page.fullPath === pageAim) currentIndex = index
      })
      // 删除打开的页面数据 并更新缓存设置
      for (let i = state.opened.length - 1; i >= 0; i--) {
        if (state.opened[i].name === 'workbench' || currentIndex === i) {
          continue
        }

        commit('keepAliveRemove', state.opened[i].name)
        state.opened.splice(i, 1)
      }
      // 设置新的页面
      state.current = pageAim
      let router = Router.getRouter();
      if (router.currentRoute.value.fullPath !== pageAim) await router.push(pageAim)
    },
    async closeAll({ state, commit, dispatch }) {
      // 删除打开的页面 并在缓存设置中删除
      for (let i = state.opened.length - 1; i >= 0; i--) {
        if (state.opened[i].name === '工作台') {
          continue
        }

        commit('keepAliveRemove', state.opened[i].name)
        state.opened.splice(i, 1)
      }
      // 关闭所有的标签页后需要判断一次现在是不是在首页
      let router = Router.getRouter();
      if (router.currentRoute.value.name !== '工作台') {
        await router.push({ path: '/workbench' })
      }
    },
    async refresh({state, commit, dispatch}){
      // const index = state.opened.findIndex((page:any) => page.fullPath === state.current)
      // let newPage: any = state.opened[index]
      // commit('keepAliveRemove', state.opened[index].name)
      // // 更新数据 删除关闭的页面
      // state.opened.splice(index, 1)
      // await dispatch('close', {tagName: state.current});
      // setTimeout(()=>{
      //   dispatch('open', newPage)
      // },1000)
    },

    ...dictActions,
  }
});

// 判定是否需要缓存
const isKeepAlive: any = (data: any) => get(data, 'meta.auth', false)

let cacheMenuList: any = {};

function getCurrentMenuAndBreadListFromStateByRoute(state: any, route: any) {
  // console.log("getCurrentMenuAndBreadListFromStateByRoute", route);
  let cacheMenuList = store.state.cacheMenuList;
  // console.log("==============cacheMenuList==================")
  // console.log(cacheMenuList);
  let url = route.fullPath;
  let path = route.matched[route.matched.length - 1].path;
  let menu = {}, breadList: any[] = [];
  let cache = cacheMenuList[url] ? cacheMenuList[url] : cacheMenuList[path];
  if (cache === undefined) {
    return { menu, breadList };
  }
  menu = cache;
  breadList = cache.breadList;

  return { menu, breadList };
}

function dfs(menuInfo: any, route: any): any {
  let result: any[] = [];
  let tmpInfo = { name: menuInfo.name, key: menuInfo.key, matchType: menuInfo.matchType };
  if (isUrlMatchPath(menuInfo, route)) {
    result.push(tmpInfo);
    return result;
  }
  if (menuInfo.menuList === undefined || menuInfo.menuList == null || menuInfo.menuList.length === 0) {
    return result;
  }
  for (let subInfo of menuInfo.menuList) {
    let tmpList = dfs(subInfo, route);
    // console.log("tmpList", tmpList);
    if (tmpList && tmpList.length > 0) {
      result.push(tmpInfo, ...tmpList);
      // console.log("result", result);
      return result;
    }
  }
}


function isUrlMatchPath(info: any, route: any) {
  let result: boolean = false;
  let matchType = info.matchType == 1 ? 1 : 0;
  if (matchType === 0) {
    result = isUrlFullPathMatch(info, route);
  } else if (matchType === 1) {
    result = isRestfulPathMatch(info, route);
  }
  return result;
}

function isUrlFullPathMatch(info: any, route: any) {
  return info.url === route.path;
}

function isRestfulPathMatch(info: any, route: any) {
  let matchedArr = route.matched;
  let latestMatchedInfo = matchedArr[matchedArr.length - 1];
  return info.url === latestMatchedInfo.path;
}


function closeAllMenuActive(state: any) {
  let menuList = state.menuList;
  let index = 0;
  while (index < menuList.length) {
    let menu = menuList[index++];
    menu.active = false;
    if (menu.menuList != null && menu.menuList.length > 0) {
      menuList = menuList.concat(menu.menuList);
    }
  }
}

function setKeyToMenuTree(data: any[], parentInfo: any = { key: "sub", breadList: [] }) {
  // console.log(data);
  let cache: any = {};
  let result = data.map((info: any, index: number) => {
    // console.log(info);
    info.key = parentInfo.key + '-' + (Number(index + 1));
    let tempList: any[] = [].concat(parentInfo.breadList);
    tempList.push({ name: info.name, key: info.key });
    info.breadList = tempList;
    if (info.data && info.data.length > 0) {
      setKeyToMenuTree(info.data, info);
    }
    cacheMenuList[info.url] = info;
    // console.log(info);
    return info;
  });
  ;
  return result;
}

const vuexFactory = {
  init: (app: App) => {
    app.use(store);
  },
  getStore: () => {
    return store;
  }
}


export default vuexFactory;
